import ScrollSnapControls from '@thinktomorrow/scroll-snap-controls';

const initCarousels = (containerSelector = '[data-ssc]') => {
    const containers = [...document.querySelectorAll(containerSelector)];

    for (const container of containers) {
        const carouselScrollSnapControls = new ScrollSnapControls(container);

        carouselScrollSnapControls.init();
    }
};

export default initCarousels;
